// Google Ads conversion events.
// The Google tag (AW-18121808922) is loaded globally in public/index.html,
// so we only need to fire the event at the moment the conversion happens.

const GOOGLE_ADS_ID = "AW-18121808922";

export const ADS_CONVERSIONS = {
  // "Partnership enquiry - Request a call" (Goals > Submit lead form)
  PARTNERSHIP_ENQUIRY: `${GOOGLE_ADS_ID}/Zqi0COzgn44dEJq4k8FD`,
  // "Brochure download - Partner Portal" (Goals > Submit lead form), /partners form
  BROCHURE_DOWNLOAD: `${GOOGLE_ADS_ID}/oTrwCKWr6podEJq4k8FD`,
  // Replace null with `${GOOGLE_ADS_ID}/<label>` after the Google Ads
  // conversion action exists. Null sends nothing.
  PURCHASE: null,
  SIGN_UP: null,
};

/**
 * Report a Google Ads conversion. Never throws — tracking must not break the UI
 * (e.g. when gtag is blocked by an ad blocker).
 */
export const trackAdsConversion = (sendTo, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", { send_to: sendTo, ...params });
    }
  } catch (_) {
    // ignore
  }
};

/**
 * Report a generic lead (gated download etc.) to every ad platform tag that is
 * loaded: GA4/Google Ads `generate_lead` and the Meta pixel `Lead`. Add a
 * dedicated Google Ads conversion label to ADS_CONVERSIONS when one exists.
 * Never throws.
 */
export const trackLead = (params = {}) => {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag === "function") window.gtag("event", "generate_lead", params);
    if (typeof window.fbq === "function") window.fbq("track", "Lead", params);
  } catch (_) {
    // ignore
  }
};
